export const forms = {
  labels: {
    firstName: "Vorname",
    lastName: "Nachname",
    email: "E-Mail",
    phone: "Telefon",
    privacyAgreement:
      "Ich erkläre mich damit einverstanden, dass die Maagtechnic AG meine Daten zur Bearbeitung meines Anliegen verwendet. Weitere Informationen und Widerrufshinweise finden Sie in unserer <a class='link link-primary' href='/datenschutz' target='__blank'><span> Datenschutzerklärung </span></a>*",
    submit: "Absenden",
  },
  hints: {
    requiredFieldsMissing: "Nicht alle Pflichtfelder ausgefüllt",
  },
  contactForm: {
    header: "Kontaktformular",
    labels: {
      subject: "Betreff",
      message: "Ihre Nachricht an uns",
      reportABug: "Ich möchte einen Problem melden",
    },
    hints: {
      maxNCharacters: "Nachricht max. {n} Zeichen",
    },
  },
  bugReport: {
    descriptions: {
      general:
        "Vielen Dank, dass Sie sich die Zeit nehmen um uns ein Problem zu melden. <br> Bitte beschreiben Sie genauer, was passiert ist.",
      optionalFields:
        "Wenn Sie eine Frage nicht beantworten können, lassen Sie das Feld einfach frei.",
      userIntention:
        "Bsp. Sie wollten eine 3D-Datei hochladen oder sich einloggen.",
      userExpectation:
        "Bsp. Ihre Datei wird analysiert oder Ihre Kundendaten werden angezeigt.",
      systemResponse:
        "Bsp. Die Analyse wird abgebrochen oder es passiert nichts.",
    },
    labels: {
      description: "Was sollten wir sonst noch wissen?",
      userIntention: "Was wollten Sie in unserem Portal tun?",
      userExpectation: "Welches Verhalten haben Sie vom Portal erwartet?",
      systemResponse: "Wie hat sich das Portal stattdessen verhalten?",
      browserUsed: "Welchen Browser verwenden Sie?",
      osUsed: "Welches Betriebssystem verwenden Sie?",
      errorMessageOccurred: "Wurde Ihnen eine Fehlermeldung angezeigt?",
      errorMessage: "Fehlermeldung",
      problemPersistInAnotherBrowser:
        "Besteht das gleiche Problem auch in einem anderen Browser?",
      iDontKnow: "Ich weiß es nicht",
      otherBrowser: "einen anderen",
      otherOs: "ein anderes",
      yes: "Ja",
      no: "Nein",
      internetConnection:
        "Können Sie andere Webseiten wie z.B. <a href='https://google.com' target='__blank'>www.google.com</a> erreichen?",
    },
    placeholders: {
      userIntention: "Aktion",
      userExpectation: "Ihre Erwartung",
      systemResponse: "Das aufgetretene Verhalten",
    },
    hints: {
      maxNCharacters: "Nachricht max. {n} Zeichen",
    },
  },
};
